<template>
  <div
    ref="container"
    @focusout="handleFocusOut"
  >
    <FloatingLabelInput
      class="!min-w-0 !m-0"
      :value="value"
      @input="debouncedNameInput"
      @blur="$emit('blur', $event)"
      @keydown.esc="handleEscKey"
      @focus="focused = true"
      :aria-label="$t('ui.envelopes.cards.partyRoleCard.partyName')"
      :placeholder="$t('ui.envelopes.cards.partyRoleCard.partyName')"
      data-ec="contact_autocomplete"
      data-et="name_input"
      :inputClasses="showOptions ? 'rounded-b-none border-b-0 !border-primary' : ''"
      :hasError="hasError"
      ref="input"
    />
    <div class="relative">
      <ul
        v-if="showOptions"
        class="absolute top-0 my-0 list-none pl-0 w-full max-h-comboBox overflow-y-auto bg-signableBrandColours-white border-solid border-1 border-primary z-100"
      >
        <li
          v-for="option in contacts"
          :key="option.id"
          class="w-full"
        >
          <button
            tabindex="0"
            @click="handleSelection(option)"
            @keydown.esc="handleEscKey"
            @keydown.enter="handleSelection(option)"
            class="text-16 text-left font-normal p-base py-sm w-full inline-block bg-signableBrandColours-white border-0 outline-none cursor-pointer text-signableBrandColours-black no-underline text-dark3 hover:bg-gray-100 focus-visible:outline-0 focus:bg-gray-100"
          >
            {{ option.title }} ({{ option.email }})
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { computed, defineProps, ref } from 'vue';
import FloatingLabelInput from '@/components/tailwind/forms/FloatingLabelInput.vue';
import { useContactSearch } from '@/composables/contacts/search';
import { useDebounceFn } from '@vueuse/core';

defineProps({
  value: {
    type: String,
    required: true,
  },
  hasError: {
    type: Boolean,
  },
});

const emit = defineEmits(['selected', 'input']);

const query = ref('');
const focused = ref(false);
const input = ref();
const container = ref();

const { contacts } = useContactSearch(query);

const showOptions = computed(() => query.value && focused.value && contacts?.value?.length);

const debouncedNameInput = useDebounceFn((event) => {
  query.value = event;
  focused.value = true;
  emit('input', event);
}, 350);

function handleSelection(event) {
  try {
    // Focus on the input upon selection
    input.value.$el.firstChild.focus();
  } catch (e) {
    // Fall through if error occurs
  }

  focused.value = false;
  query.value = '';
  emit('selected', event);
}

function handleEscKey() {
  focused.value = false;
}

function handleFocusOut(event) {
  if (!container.value.contains(event.relatedTarget)) {
    focused.value = false;
  }
}

</script>
